import React from 'react';
import { withRouter } from 'react-router-dom';

import ProfileStepper from './Stepper';
import './ProfileSetup.css';

const BENEFITS = [
  'Get matched with brands that fit your niche',
  'Show your audience and post performance in one place',
  'Raise invoices and track payments to payout',
];

class ProfileSetup extends React.Component {
  render() {
    return (
      <div className="ps-wrap">
        <aside className="ps-aside">
          <div className="ps-aside-inner">
            <p className="ps-kicker">Welcome to Influencer.in</p>
            <h1 className="ps-title">Complete your creator profile</h1>
            <p className="ps-sub">
              A few quick details help us understand you and your audience, so we can put
              the right brands in front of you.
            </p>
            <ul className="ps-benefits">
              {BENEFITS.map((benefit) => (
                <li className="ps-benefit" key={benefit}>
                  <span className="ps-benefit-tick" aria-hidden="true">
                    ✓
                  </span>
                  <span>{benefit}</span>
                </li>
              ))}
            </ul>
          </div>
        </aside>

        <section className="ps-main">
          <h2 className="ps-main-head">Account setup</h2>
          <p className="ps-main-sub">Step through the details below to get started.</p>
          <ProfileStepper />
        </section>
      </div>
    );
  }
}

export default withRouter(ProfileSetup);
